import React from "react";
import SecondTable from "../SecondTable";

const columns = [
  {
    label: "Pokedex",
    accessor: "pokedex",
    sortable: true
  },
  {
    label: "Name",
    accessor: "name",
    sortable: true
  },
  {
    label: "Evolution",
    accessor: "evo",
    sortable: true
  },
  {
    label: "Description",
    accessor: "desc",
    sortable: false
  },
  {
    label: "Is Exclusive",
    accessor: "exclusive",
    sortable: true
  },
  {
    label: "Type(s)",
    accessor: "type",
    sortable: true
  },
  {
    label: "Is Caught",
    accessor: "isCaught",
    sortable: false
  }
];

const SecondTab = ({ data }) => {
  return (
    <div className="tab content">
      <SecondTable caption="Caught Pokemon" data={data} columns={columns} />
    </div>
  );
};
export default SecondTab;
